export const customeStyle = {
    sucessColor:"#dd4498",
    errorColor:"#688ad5",
    fadedGrey:"gray",
   typography: {
  subhading: {
    lg: "clamp(0.85rem, 0.7vw, 0.95rem)",
    md: "clamp(0.85rem, 0.7vw, 0.95rem)",
    sm: "clamp(0.85rem, 0.7vw, 0.95rem)",
    xs: "clamp(0.85rem, 0.7vw, 0.95rem)",
  },
  subhading1: {
    lg: "clamp(0.75rem, 0.5vw, 0.85rem)",
    md: "clamp(0.75rem, 0.5vw, 0.85rem)",
    sm: "clamp(0.75rem, 0.5vw, 0.85rem)",
    xs: "clamp(0.75rem, 0.5vw, 0.85rem)",
  },
},
    buttomfont:"0.875rem",
    buttomfont1:"0.7rem"

}